import {fromJS} from 'immutable';

const defState = fromJS({
    type: 'windows',
    sliderValues: {
        width: {doors: 700, windows: 700},
        height: {doors: 700, windows: 700},
    },
    sliderParameters: {
        width: {
            doors: {
                min: 700,
                max: 1000,
            },
            windows: {
                min: 500,
                max: 2100,
            }
        },
        height: {
            doors: {
                min: 2000,
                max: 2150,
            },
            windows: {
                min: 500,
                max: 1600,
            }
        },
        step: {
            doors: 50,
            windows: 50,
        },
    },
    types: [],
});

export default function reducer(state = defState, action) {
    switch (action.type) {
        case 'FLIP_FILTER_SWITCH': {
            if (state.get('type') === 'windows') {
                return state.set('type', 'doors');
            } else {
                return state.set('type', 'windows');
            }
        }
        case 'SET_DIMENSIONS': {
            const {param, value} = action.payload;
            const type = state.get('type');
            return state.setIn(['sliderValues', param, type], value);
        }
        case 'TOGGLE_FILTER_TYPE': {
            return state.update('types', (types) => {
                let index = types.indexOf(action.payload);
                if(index > -1){
                    return types.delete(index);
                }
                else {
                    return types.push(action.payload);
                }
            });
        }
        default:
            return state;
    }
};